export const PRODUCT_LINKS = [{
  id: 1,
  title: 'Project Management',
  url: '#'
}, {
  id: 2,
  title: 'Multi-tenancy',
  url: '#'
}, {
  id: 3,
  title: 'Scalability',
  url: '#'
}, {
  id: 4,
  title: 'Customization',
  url: '#'
}, {
  id: 5,
  title: 'Integration',
  url: '#'
}, {
  id: 6,
  title: 'Mobile accessibility',
  url: '#'
}, {
  id: 7,
  title: 'Analytics and reporting',
  url: '#'
}];
export const FEATURE_LINKS = [{
  id: 1,
  title: 'User management',
  url: '#'
}, {
  id: 2,
  title: 'Workflow automation',
  url: '#'
}, {
  id: 3,
  title: 'API access',
  url: '#'
}, {
  id: 4,
  title: 'Data visualization',
  url: '#'
}, {
  id: 5,
  title: 'Version control',
  url: '#'
}, {
  id: 6,
  title: 'Upgrades',
  url: '#'
}, {
  id: 7,
  title: 'Billing and invoicing',
  url: '#'
}];
export const EXPLORE_LINKS = [{
  id: 1,
  title: 'Docs',
  url: '#'
}, {
  id: 2,
  title: 'Pricing',
  url: '#'
}, {
  id: 3,
  title: 'Integrations',
  url: '#'
}, {
  id: 4,
  title: 'Blog',
  url: '#'
}, {
  id: 5,
  title: 'About',
  url: '#'
}];